// @flow
import React, { type Node } from "react";
import { GridUc, SetupCard } from "@fas/ui-core";
import {
  Box, Grid, Link, Switch, Typography,
} from "@mui/material";
import NamedItem from "../NamedItem";
import Collapse from "../Collapse/Collapse";
import CardDivider from "../CardDivider";
import type { Classes } from "../../containers/CampaignView";
import type { MessageGroupListItem } from "../MessageGroupsList/types/MessageGroupsList.types";
import type { BrowserLanguage } from "../../containers/CreateMessageGroup";

type Props = {
  campaignContent: MessageGroupListItem[],
  classes: Classes,
}

const CampViewWPMessages = ({ campaignContent, classes }: Props) => (
  <SetupCard title="Message Groups">
    {campaignContent.map((messageGroup: MessageGroupListItem, index: number): Node => (
      <Box width="100%" key={messageGroup.id} className={classes.root}>
        <NamedItem name="Id" value={messageGroup.id || ""} />
        <GridUc
          mt={3}
          px={3}
          container
          direction="row"
          alignItems="center"
        >
          <Grid item xs={3}>
            <Typography variant="body2" color="textSecondary">Name</Typography>
          </Grid>
          <Grid item xs={9}>
            <Link
              href={`/messageGroups/view/${messageGroup.id || ""}`}
              target="_blank"
              underline="hover"
            >
              {messageGroup.name}
            </Link>
          </Grid>
        </GridUc>
        <GridUc
          mt={3}
          px={3}
          container
          direction="row"
          alignItems="center"
        >
          <Grid item xs={3}>
            <Typography variant="body2" color="textSecondary">isActive</Typography>
          </Grid>
          <Grid item xs={9}>
            <Switch checked={messageGroup.isActive} disabled />
          </Grid>
        </GridUc>
        <NamedItem name="Placements" value={messageGroup.placements} />
        <NamedItem
          name="Sending strategy"
          // $FlowFixMe
          value={messageGroup.sendStrategies.name}
        />
        <GridUc
          mt={3}
          px={3}
          container
          direction="row"
          alignItems="center"
        >
          <Grid item xs={3}>
            <Typography variant="body2" color="textSecondary">Browser Languages</Typography>
          </Grid>
          <Grid item xs={9}>
            <Collapse
              list={messageGroup.browserLanguages.map(
                (item: BrowserLanguage): {name: string} => ({ name: item.language })
              )}
              limit={2}
              showMoreDisabled={false}
            />
          </Grid>
        </GridUc>
        <Box mt={3}>
          <CardDivider visible={index < campaignContent.length - 1} />
        </Box>
      </Box>
    ))}
  </SetupCard>
);

export default CampViewWPMessages;
